import React, {useState, useEffect} from "react";
import { BRAND_LIST_URL } from "../../utils/urls";
import instance from "../../services/services";
import { useNavigate } from 'react-router-dom';
import { useLanguage } from "../../hooks/useLanguage";

function Brand({isOpen, onDimHover, onMenuClick }){
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isTab, setIsTab] = useState('recommend');  
  const [brandList, setBrandList] = useState([]);

  // getBrandList 함수를 컴포넌트 내부로 이동하고 orderby 파라미터 추가
  const getBrandList = async (orderBy = 'recommend') => {
    try{
      const response = await instance.post(BRAND_LIST_URL, {
        orderby: orderBy
      });
      setBrandList(response.data.data);
    } catch (error) {
      console.error("브랜드 리스트 조회 오류:", error);
    }
  };

  useEffect(()=> {
    // 초기 로드 시 recommend 기본값으로 호출
    getBrandList('recommend');
  }, []);

  if (!isOpen) return null;
  
  const handleTab = (tabName)=>{
    setIsTab(tabName);
    // 탭 변경 시 해당하는 orderby 값으로 API 재호출
    const orderBy = tabName === 'recommend' ? 'recommend' : 'name';
    getBrandList(orderBy);
  };

  const handleBrandClick = async (brand) => {
    // 기존 로직 주석 처리
    const queryParams = new URLSearchParams({
        title: brand.brand_name,
        brand_seq: brand.brand_seq,
        brand_url: brand.brand_url
    });

    if (onMenuClick) {
      onMenuClick('brand'); // 클릭된 메뉴 노란박스 (Header에서 active 표시용)
    }
    
    navigate(`/category/brandPage?${queryParams.toString()}`, {
    });

    handleClose();

  };

    // 닫기 버튼 클릭 핸들러 추가
    const handleClose = () => {
      if (onDimHover) {
        onDimHover();
      }
    };

  return(
    <div>
      {/* pc 브랜드 드롭다운 메뉴  */}
      <div className="dropdown_menu header_ctg brand_drop">
        <div style={{width: '100%', background: 'rgb(255, 255, 255)'}} onMouseLeave={onDimHover}>
          <div className="inner">

            <div className="brand_navi">
              <div className="main_tit">BRAND</div>
              <div className="brand_list_wrap">
                <div 
                  className={`brand_list_title ${isTab === 'recommend' ? 'active' :''}`}
                  onClick={() => handleTab('recommend')}
                >{t('recommended_order')}</div>
                <div 
                  className={`brand_list_title ${isTab === 'az' ? 'active' :''}`}
                  onClick={() => handleTab('az')}
                >{t('sort_az')}</div>
              </div>
              
              <div className="brand_contents">
                {/* 추천 순위 */}
                <ul className={`brand_list ${ isTab === 'recommend' ?  'active' : ''}`}>
                  {brandList.map((brand) => (
                    <li key={brand.brand_seq}>
                      <div>
                        <span className="brand_border" onClick={() => handleBrandClick(brand)}>
                          <img 
                            alt={brand.brand_name} 
                            src={brand.brand_img}
                            className="object-contain"
                            loading="lazy"
                          />
                        </span>
                        <span className="sub_tit">{brand.brand_name}</span>
                      </div>
                  </li>
                  ))}
                </ul>
                                  
                {/* A-Z 순위 */}
                <ul className={`brand_list ${ isTab === 'az' ?  'active' : ''}`}>
                  {brandList.map((brand) => (
                    <li key={brand.brand_seq}>
                      <div>
                        <span className="brand_border" onClick={() => handleBrandClick(brand)}>
                          <img 
                            alt={brand.brand_name} 
                            src={brand.brand_img}
                            className="object-contain"
                            loading="lazy"
                          />
                        </span>
                        <span className="sub_tit">{brand.brand_name}</span>
                      </div>
                  </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="menu_dim"></div>
      </div>


      {/* mobile 브랜드 드롭다운 메뉴  */}
      <div className="header_ctg mo_brand">
          <div className="mo_parent">
            <div className="mo_brand_inner">
              <div className="inner">
                <div className="side_top">
                  <button 
                      className="close_btn" 
                      type="button" 
                      onClick={handleClose}
                  />         
                </div>

                <div className="brand_navi">
                  <div className="main_tit">BRAND</div>
                  <div className="brand_list_wrap">
                    <div 
                      className={`brand_list_title ${isTab === 'recommend' ? 'active' :''}`}
                      onClick={() => handleTab('recommend')}
                    >추천 순위</div>
                    <div 
                      className={`brand_list_title ${isTab === 'az' ? 'active' :''}`}
                      onClick={() => handleTab('az')}
                    >A-Z 순위</div>
                  </div>
                  
                  <div className="brand_contents">
                    {/* 추천 순위 */}
                    <ul className={`brand_list ${ isTab === 'recommend' ?  'active' : ''}`}>
                      {brandList.map((brand) => (
                        <li key={brand.brand_seq}>
                          <div>
                            <span className="brand_border" onClick={() => handleBrandClick(brand)}>
                              <img 
                                alt={brand.brand_name} 
                                src={brand.brand_img}
                                className="object-contain"
                                loading="lazy"
                              />
                            </span>
                            {/* 모바일에서 브랜드 이름 비노출 처리로 인한 주석 */}
                            <span className="sub_tit">{brand.brand_name}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                                      
                    {/* A-Z 순위 */}
                    <ul className={`brand_list ${ isTab === 'az' ?  'active' : ''}`}>
                      {brandList.map((brand) => (
                        <li key={brand.brand_seq}>
                          <div>
                            <span className="brand_border" onClick={() => handleBrandClick(brand)}>
                              <img 
                                alt={brand.brand_name} 
                                src={brand.brand_img}
                                className="object-contain"
                                loading="lazy"
                              />
                            </span>
                            <span className="sub_tit">{brand.brand_name}</span>
                          </div>
                      </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div className="menu_dim"  onClick={handleClose}></div>
      </div>

      
    </div>
  )
};

export default Brand;